/**
 * SHARED
 * Cross-cutting code usable by any module. Must not import from any module.
 */

import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../utils/supabaseClient.js";
import BrandLogo from "./BrandLogo.jsx";
import { TRIAL_DAYS } from "../billingConfig.js";
import { LegalConsent } from "./LegalLinks.jsx";

export default function SignUp() {
  const [company, setCompany]   = useState("");
  const [email, setEmail]       = useState("");
  const [password, setPassword] = useState("");
  const [status, setStatus]     = useState(null);
  const [busy, setBusy]         = useState(false);
  const navigate = useNavigate();

  async function handleSubmit(e) {
    e.preventDefault();
    setBusy(true);
    setStatus(null);
    try {
      const { data, error } = await supabase.auth.signUp({
        email,
        password,
        options: {
          emailRedirectTo: `${window.location.origin}/auth/callback`,
          // Names the user's workspace/company; read by the signup DB trigger.
          data: { company_name: company.trim().slice(0, 120) },
        },
      });
      if (error) throw error;
      if (data.session) {
        // Email confirmation off -> session ready immediately. Send to billing.
        navigate("/subscribe", { replace: true });
      } else {
        setStatus({ ok: true, msg: "Check your email to confirm your account, then sign in." });
      }
    } catch (err) {
      setStatus({ ok: false, msg: err.message || "Sign up failed." });
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="auth-wrap">
      <section className="auth-card">
        <div className="auth-logo">
          <BrandLogo />
        </div>
        <h1>Create your account</h1>
        <p className="auth-sub">{TRIAL_DAYS}-day free trial. No credit card required to start.</p>

        <form onSubmit={handleSubmit}>
          <label>
            Company / team name
            <input
              type="text"
              value={company}
              onChange={(e) => setCompany(e.target.value)}
              required
              maxLength={120}
              placeholder="Acme Beverages"
              autoComplete="organization"
            />
          </label>
          <label>
            Email
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoComplete="email"
            />
          </label>
          <label>
            Password
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={8}
              autoComplete="new-password"
            />
          </label>
          <button className="btn" type="submit" disabled={busy}>
            {busy ? "Creating..." : "Start free trial"}
          </button>
          {/* Directly under the button, inside the form: the Terms bind on
              account creation, so the statement belongs at the moment of the
              act, not in a footer the user scrolls past. */}
          <LegalConsent />
        </form>

        {status && <p className={status.ok ? "success" : "error"}>{status.msg}</p>}

        <p className="auth-foot muted">
          Already have an account? <Link to="/login">Log in</Link>
        </p>
      </section>
    </div>
  );
}
